import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Zap, BookOpen, Wrench, Settings, Sun, FileText, Video } from 'lucide-react';
const volumes = [{
  year: '1°',
  color: 'bg-navy',
  title: 'RESIDENCIAL'
}, {
  year: '2°',
  color: 'bg-navy',
  title: 'PLANOS'
}, {
  year: '3°',
  color: 'bg-navy',
  title: 'MOTORES'
}, {
  year: '4°',
  color: 'bg-navy',
  title: 'INDUSTRIAL'
}, {
  year: '5°',
  color: 'bg-navy',
  title: 'SOLAR'
}];
const details = [{
  title: 'MÓDULO 1 — ELECTRICIDAD RESIDENCIAL',
  desc: 'Instalaciones de viviendas, tableros, circuitos básicos, seguridad eléctrica y conceptos esenciales.',
  icon: <Wrench className="text-navy w-8 h-8" data-id="element-220" />
}, {
  title: 'MÓDULO 2 — PLANOS Y DIAGRAMAS',
  desc: 'Lectura e interpretación de planos, esquemas eléctricos, simbología y conexiones.',
  icon: <FileText className="text-navy w-8 h-8" data-id="element-221" />
}, {
  title: 'MÓDULO 3 — MOTORES Y COMANDOS',
  desc: 'Conexión de motores monofásicos, trifásicos, comandos eléctricos y sistemas de potencia.',
  icon: <Settings className="text-navy w-8 h-8" data-id="element-222" />
}, {
  title: 'MÓDULO 4 — ELECTRICIDAD INDUSTRIAL',
  desc: 'Automatismos, tableros de control, mantenimiento, protecciones y aplicaciones industriales.',
  icon: <Zap className="text-navy w-8 h-8" data-id="element-223" />
}, {
  title: 'MÓDULO 5 — ENERGÍA SOLAR',
  desc: 'Introducción a paneles solares, inversores, sistemas fotovoltaicos y energía limpia.',
  icon: <Sun className="text-navy w-8 h-8" data-id="element-224" />
}];
export function ProductBreakdown() {
  return <section className="py-12 md:py-20 px-4 max-w-5xl mx-auto" data-id="element-225">
      <div className="text-center mb-10 md:mb-16" data-id="element-226">
        <div className="inline-flex items-center gap-2 bg-slate-200 text-navy font-black tracking-widest text-xs md:text-sm uppercase mb-6 px-4 py-2 rounded" data-id="element-227">
          <BookOpen size={18} data-id="element-228" />
          <span data-id="element-229">Contenido del MEGA KIT PRO</span>
        </div>
        <h2 className="text-3xl md:text-6xl font-black text-navy mb-6 leading-tight" data-id="element-230">
          LOS 5 MÓDULOS MAESTROS
        </h2>
        <p className="text-slate-600 font-semibold text-base md:text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-231">
          Más de 25 manuales organizados paso a paso. Desde lo básico en
          residencias hasta automatización industrial y energía solar.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-6 mb-12 md:mb-20" data-id="element-232">
        {volumes.map((v, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className={`${v.color} aspect-square md:aspect-[3/4] rounded flex flex-col items-center justify-center text-electric border-b-4 border-electric shadow-lg relative overflow-hidden group hover:-translate-y-1 transition-transform`} data-id="element-233">
            <span className="font-black text-3xl md:text-5xl relative z-10" data-id="element-234">
              {v.year}
            </span>
            <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest mt-2 relative z-10 text-white text-center px-2" data-id="element-235">
              {v.title}
            </span>
          </motion.div>)}
      </div>

      <div className="space-y-6 md:space-y-8" data-id="element-236">
        {details.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white p-6 md:p-8 rounded border border-slate-200 shadow-sm flex flex-col md:flex-row gap-6 items-start hover:shadow-md transition-shadow" data-id="element-237">
            <div className="bg-slate-100 p-4 rounded shrink-0 border border-slate-200" data-id="element-238">
              {item.icon}
            </div>
            <div data-id="element-239">
              <h4 className="font-black text-navy text-lg md:text-xl mb-2 leading-tight" data-id="element-240">
                {item.title}
              </h4>
              <p className="text-slate-600 text-sm md:text-lg leading-relaxed font-medium" data-id="element-241">
                {item.desc}
              </p>
            </div>
          </motion.div>)}

        {/* Block A: Library Feature */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy p-8 md:p-12 rounded text-white shadow-xl relative overflow-hidden mt-12 border-l-4 border-electric" data-id="element-242">
          <div className="relative z-10 flex flex-col md:flex-row gap-8 items-start" data-id="element-243">
            <div className="bg-white/10 p-5 rounded shrink-0 border border-white/20" data-id="element-244">
              <FileText className="text-electric w-12 h-12" data-id="element-245" />
            </div>
            <div data-id="element-246">
              <h4 className="font-black text-2xl md:text-3xl mb-4 leading-tight text-electric" data-id="element-247">
                BIBLIOTECA TÉCNICA PRO™
              </h4>
              <p className="text-slate-300 text-base md:text-xl leading-relaxed font-medium mb-6" data-id="element-248">
                150+ fichas ilustradas con esquemas, conexiones y simbología
                para resolver dudas en el sitio de la obra.
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-white text-sm md:text-base font-semibold mb-6" data-id="element-249">
                {['Simbología universal', 'Cálculo de cargas', 'Esquemas de motores', 'Protecciones térmicas', 'Energía solar'].map((topic, idx) => <li key={idx} className="flex items-center gap-2" data-id="element-250">
                    <div className="w-5 h-5 rounded bg-electric flex items-center justify-center shrink-0" data-id="element-251">
                      <span className="text-navy text-xs font-black" data-id="element-252">✓</span>
                    </div>
                    {topic}
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Block B: Practical Component */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded border-2 border-slate-200 shadow-lg flex flex-col md:flex-row gap-8 items-start mt-8" data-id="element-253">
          <div className="bg-slate-100 p-5 rounded shrink-0 border border-slate-200" data-id="element-254">
            <Video className="text-navy w-12 h-12" data-id="element-255" />
          </div>
          <div data-id="element-256">
            <h4 className="font-black text-navy text-2xl md:text-3xl mb-4 leading-tight" data-id="element-257">
              MÁS DE 100 VIDEO-CLASES Y GUÍAS PRÁCTICAS
            </h4>
            <p className="text-slate-600 text-base md:text-xl leading-relaxed font-medium mb-6" data-id="element-258">
              Aprende visualmente el diagnóstico de fallas, protocolos de
              mantenimiento y reparación de herramientas eléctricas paso a paso.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}